/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AnneeFormationSuivieFichierDto
 */
export interface AnneeFormationSuivieFichierDto {
    /**
     * 
     * @type {number}
     * @memberof AnneeFormationSuivieFichierDto
     */
    idanneeFormationSuivieFichier?: number;
    /**
     * 
     * @type {number}
     * @memberof AnneeFormationSuivieFichierDto
     */
    idanneeFormationSuivie?: number;
    /**
     * 
     * @type {number}
     * @memberof AnneeFormationSuivieFichierDto
     */
    idfichier?: number;
    /**
     * 
     * @type {number}
     * @memberof AnneeFormationSuivieFichierDto
     */
    idtypeAcquisFichier?: number;
    /**
     * 
     * @type {string}
     * @memberof AnneeFormationSuivieFichierDto
     */
    fileName?: string | null;
}

/**
 * Check if a given object implements the AnneeFormationSuivieFichierDto interface.
 */
export function instanceOfAnneeFormationSuivieFichierDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function AnneeFormationSuivieFichierDtoFromJSON(json: any): AnneeFormationSuivieFichierDto {
    return AnneeFormationSuivieFichierDtoFromJSONTyped(json, false);
}

export function AnneeFormationSuivieFichierDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): AnneeFormationSuivieFichierDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'idanneeFormationSuivieFichier': !exists(json, 'idanneeFormationSuivieFichier') ? undefined : json['idanneeFormationSuivieFichier'],
        'idanneeFormationSuivie': !exists(json, 'idanneeFormationSuivie') ? undefined : json['idanneeFormationSuivie'],
        'idfichier': !exists(json, 'idfichier') ? undefined : json['idfichier'],
        'idtypeAcquisFichier': !exists(json, 'idtypeAcquisFichier') ? undefined : json['idtypeAcquisFichier'],
        'fileName': !exists(json, 'fileName') ? undefined : json['fileName'],
    };
}

export function AnneeFormationSuivieFichierDtoToJSON(value?: AnneeFormationSuivieFichierDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'idanneeFormationSuivieFichier': value.idanneeFormationSuivieFichier,
        'idanneeFormationSuivie': value.idanneeFormationSuivie,
        'idfichier': value.idfichier,
        'idtypeAcquisFichier': value.idtypeAcquisFichier,
        'fileName': value.fileName,
    };
}

